import { PARTICIPATION_REPORT_RETRIEVED } from './participation-report-actions';
import { DOWNLOAD_SERVICE_IS_ACTIVE } from '../certificates/download-certificates-actions';

const defaultState = null;

/**
 * Participation Report Reducer
 *
 * Consumes PARTICIPATION_REPORT_RETRIEVED action
 *
 * @param {object} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {object} - current participation report info
 */
export default function (state = defaultState, action) {
    if (!action) return state;

    switch (action.type) {
    case PARTICIPATION_REPORT_RETRIEVED:
        /*
            * {
        "studentProfileId": 100009676,
        "studentCertificateInfo": {
            "gold": 0,
            "silver": 0,
            "bronze": 0,
            "studentCertificateDetails": []
        },
        "participationInfo": {
            "liveMathsPoints": 0,
            "activityPoints": 0,
            "skillQuestsPoints": 0
        },
        "logInInfo": {
            "totalSignIns": 0,
            "totalTime": {
                "hours": 0,
                "minutes": 0
            }
        },
        "courseResult": {
            "totalCappedPoints": 0,
            "goldBars": 0,
            "courseResults": []
        },
        "liveMathsResult": {
            "maxLiveMathsLevels": 10,
            "liveMathsInfo": [],
            "averageCorrect": 0.0,
            "totalPoints": 0
        },
        "newCertificateSummary": {
            "bronze": 5,
            "silver": 2,
            "gold": 0,
            "platinum": 0,
            "emerald": 0,
            "diamond": 0,
            "epic": 0,
            "legend": 0,
            "total": 7
        },
        newCoursesResult = [
            {
                courseId: 0,
                courseName: 'courseName',
                averageAccuracy: 30,
                allActivities: [
                    {
                        accuracy: 0,
                        completionDate: '2023-11-28T11:31:43.134Z',
                        id: 0,
                        name: 'name'
                    }
                ]
              }
            ],
        questCourseResult = [
            {
                courseId: 0,
                courseName: 'courseName',
                averageAccuracy: 30,
                allActivities: [
                    {
                        accuracy: 0,
                        completionDate: '2023-11-28T11:31:43.134Z',
                        id: 0,
                        name: 'name'
                    }
                ]
              }
            ];
        } */
        return action.payload;

    case DOWNLOAD_SERVICE_IS_ACTIVE: {
        const { isActive } = action.payload;
        return { isActive };
    }

    default:
        return state;
    }
}



// WEBPACK FOOTER //
// ./containers/participation-report/participation-report-reducer.js